// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f26F","badges":"styles_badges__cgCq2"};